var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 216,
    viewBox: "0 0 208 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#img-info_svg__clip0_4211_60159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.97 48.272h89.62c8.274 0 14.976-6.702 14.976-14.975V0H4.994v33.297c0 8.273 6.702 14.975 14.976 14.975z",
    fill: "#D8D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.411 186.291H44.175c-8.274 0-14.976 6.702-14.976 14.975v14.735h143.187v-14.735c0-8.273-6.702-14.975-14.975-14.975z",
    fill: "#B4F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.648 83.584h-43.384c-8.27 0-14.975 6.705-14.975 14.975v40.23c0 8.271 6.705 14.976 14.975 14.976h43.384c8.27 0 14.975-6.705 14.975-14.976v-40.23c0-8.27-6.705-14.975-14.975-14.975z",
    fill: "#94C4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.804 74.732h-43.383c-8.271 0-14.976 6.705-14.976 14.976v40.23c0 8.27 6.705 14.975 14.976 14.975h43.383c8.271 0 14.975-6.705 14.975-14.975v-40.23c0-8.27-6.704-14.976-14.975-14.976z",
    fill: "#8DF7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.944 35.862H17.617a3.047 3.047 0 010-6.094h94.327a3.047 3.047 0 010 6.094z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.484 35.862H17.618a3.047 3.047 0 010-6.094h67.866a3.047 3.047 0 010 6.094z",
    fill: "#A9A9F4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M165.886 166.782c12.137 0 21.976-9.839 21.976-21.976 0-12.137-9.839-21.976-21.976-21.976-12.137 0-21.976 9.839-21.976 21.976 0 12.137 9.839 21.976 21.976 21.976z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.921 175.702l-14.513-16.065a26.031 26.031 0 004.581-13.509c.356-6.972-2.025-13.664-6.712-18.843-4.677-5.178-11.099-8.225-18.07-8.582-6.982-.347-13.664 2.025-18.843 6.712-10.694 9.662-11.532 26.219-1.87 36.913 5.149 5.698 12.265 8.601 19.401 8.601 4.629 0 9.257-1.225 13.375-3.684l14.387 15.921a5.557 5.557 0 007.859.395c2.276-2.063 2.459-5.583.395-7.859h.01zm-49.256-18.948a17.68 17.68 0 01-4.571-12.844 17.665 17.665 0 015.854-12.314 17.687 17.687 0 0111.918-4.6 17.695 17.695 0 0113.24 5.863 17.68 17.68 0 014.571 12.844 17.7 17.7 0 01-5.844 12.314c-7.29 6.586-18.582 6.017-25.158-1.273l-.01.01z",
    fill: "#03D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.874 106.467l-12.034-6.953c-2.584-1.495-5.824.376-5.824 3.356v13.895c0 2.989 3.23 4.851 5.824 3.356l12.034-6.953c2.584-1.494 2.584-5.226 0-6.721v.02z",
    fill: "#308CFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.113 122.579l3.047 8.582a1.478 1.478 0 002.026.839l8.225-3.905c1.253-.598 2.565.714 1.967 1.967l-3.905 8.225c-.377.791.01 1.736.839 2.025l8.582 3.048c1.311.462 1.311 2.314 0 2.777l-8.582 3.047a1.478 1.478 0 00-.84 2.025l3.906 8.225c.598 1.254-.714 2.565-1.967 1.967l-8.226-3.905a1.472 1.472 0 00-2.025.839l-3.047 8.582c-.462 1.312-2.314 1.312-2.777 0l-3.047-8.582a1.478 1.478 0 00-2.025-.839l-8.225 3.905c-1.254.598-2.565-.713-1.967-1.967l3.905-8.225a1.471 1.471 0 00-.839-2.025l-8.582-3.047c-1.312-.463-1.312-2.315 0-2.777l8.582-3.048a1.478 1.478 0 00.839-2.025l-3.905-8.225c-.598-1.253.713-2.565 1.967-1.967L32.264 132a1.471 1.471 0 002.025-.839l3.047-8.582c.463-1.311 2.315-1.311 2.777 0z",
    fill: "#62A8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.656 111.693a5.216 5.216 0 100-10.433 5.216 5.216 0 100 10.433z",
    fill: "#25E9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.857 23.48h-26.585c-7.763 0-14.108 6.346-14.108 14.108 0 7.213 5.487 13.201 12.497 14.011v5.844c0 3.201 3.867 4.802 6.133 2.536l8.283-8.283h13.78c7.762 0 14.107-6.346 14.107-14.108 0-7.762-6.345-14.108-14.107-14.108z",
    fill: "#94C4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.014 40.808a3.019 3.019 0 100-6.038 3.019 3.019 0 000 6.038zM179.569 40.808a3.018 3.018 0 100-6.036 3.018 3.018 0 000 6.036zM192.114 40.808a3.018 3.018 0 100-6.036 3.018 3.018 0 000 6.036z",
    fill: "#62A8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.804 102.205c-3.597 0-7.145-.878-10.328-2.556-1.022-.54-1.33-1.87-.694-2.844l2.883-4.369c.56-.848 1.659-1.109 2.585-.675a12.947 12.947 0 006.952 1.177 12.831 12.831 0 008.66-4.754 12.823 12.823 0 002.834-7.782c.02-.993.82-1.803 1.813-1.91l5.16-.568c1.156-.125 2.207.762 2.217 1.928a21.88 21.88 0 01-4.86 14.07 21.977 21.977 0 01-14.821 8.138c-.8.087-1.6.135-2.401.135v.01z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "img-info_svg__clip0_4211_60159"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h208v216H0z"
  })))));
}

export default __webpack_public_path__ + "87f87097.svg";
export { SvgImgInfo as ReactComponent };